import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { Daycare } from '@/types/Daycare'
import ReprintReportDialog from './ReprintReportDialog.tsx'

interface ExportReprintReportProps {
    daycares: Daycare[]
    fromGroup: boolean
    minDate: string
}

const ExportReprintReport: FunctionComponent<ExportReprintReportProps> = ({
    daycares,
    fromGroup,
    minDate
}: ExportReprintReportProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{t('reprintReport')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ReprintReportDialog
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={minDate}
                    fromGroup={fromGroup}
                />
            )}
        </>
    )
}

export default ExportReprintReport
